// Snap an approximate AI box onto the exact PDF text that holds the recognised value ("V45-LG", "1 790" -> "1790").
const norm = (s) => String(s ?? "").toLowerCase().replace(/[\s\u00a0]/g, "").replace(/,/g, ".");
const center = (b) => [(b[0] + b[2]) / 2, (b[1] + b[3]) / 2];

export function snapBox(items, value, box) {
    const v = norm(value);
    if (v.length < 2 || !box || !items?.length) return null;
    const [cx, cy] = center(box);
    let best = null, hits = 0;
    for (const ti of items) {
        const raw = ti.s, n = norm(raw), at = n.indexOf(v);
        if (at < 0) continue;
        let b = ti.box;
        if (n.length > v.length) {
            const map = [];
            for (let i = 0; i < raw.length; i++) if (!/[\s\u00a0]/.test(raw[i])) map.push(i);
            const s0 = map[at], s1 = map[at + v.length - 1] + 1, L = raw.length, w = b[2] - b[0], h = b[3] - b[1];
            if (w >= h) b = [b[0] + (w * s0) / L, b[1], b[0] + (w * s1) / L, b[3]];
        }
        const [x, y] = center(b);
        const d = Math.hypot(x - cx, y - cy) + (n.length > v.length ? 0.01 : 0);
        hits += 1;
        if (!best || d < best.d) best = { b, d };
    }
    if (!best || (hits > 1 && best.d > 0.35)) return null;
    const p = 0.0015;
    return [best.b[0] - p, best.b[1] - p, best.b[2] + p, best.b[3] + p];
}
